import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React, { useState } from 'react';

import ForgotInfoForm from '../components/forgot-info';

import { baseTheme } from '../theme';
import { sendPasswordResetEmail } from '../services/auth/service';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),

    },
    sectionContainer: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
    paperRoot: {
      paddingTop: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
    },
    headerSpacing: {
      marginBottom: theme.spacing(1),
    },
    contentRoot: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  }),
);

export default function ForgotInfoPage() {
  const [emailSent, setEmailSent] = useState(false);
  const classes = useStyles(baseTheme);
  const triggerUsernameResetEmail = null;
  const triggerPasswordResetEmail = (formValues: any) => {
    sendPasswordResetEmail(formValues.email)
        .then(() => {
          setEmailSent(true);
        })
        .catch((error: any) => {
          console.log(error);
        });
  };
  return (
    <Grid item container direction="column" className={classes.root}>
      <Typography variant="h4" color="primary">
        Forgot Password
      </Typography>

      <Grid item xs={6}>
          {!emailSent &&
          <ForgotInfoForm
              resetType="password"
              heading="Reset Password"
              description="Enter the email of your account to reset password."
              sendEmail={triggerPasswordResetEmail}
          />}
          {emailSent &&
          <Grid container item className={classes.root}>
              <Grid item xs={12} className={classes.contentRoot}>
                  <Typography variant="h5" color="primary" className={classes.headerSpacing}>
                      Password Reset
                  </Typography>
                  Instructions to reset password have been sent to your email account.
              </Grid>
          </Grid>}
      </Grid>
    </Grid>
  );
}
